module.exports = __webpack_public_path__ + "img/s3.423e68d0.png";